<template>
  <div class="profile-info">
    <div class="profile-info__details has-text-white" :class="profileBoxStyle">
      <div class="status-box">
        <pill v-if="studentProfile.activeAlerts > 0" status="tertiary">
          <icon-warning-white /> Con alertas
        </pill>
        <a
          v-if="canEditEnrollmentState"
          class="edit-btn"
          href="#"
          @click.prevent="navigateTo('app.profile.change_situation')"
        >
          <edit-icon style="width: 1.5em; height: 1.5em;" />
        </a>
      </div>

      <div class="basic-info columns" style="position: relative;">
        <div class="profile-pic column is-narrow">
          <div class="profile-pic-box">
            <div v-if="studentProfile.student.avatar && !avatarFailed">
              <img
                class="profile-avatar-img"
                :src="studentProfile.student.avatar"
                @error="disableAvatar"
              />
            </div>
            <div v-else>
              <male-avatar />
            </div>
          </div>
        </div>
        <div class="basic-info-content column">
          <p class="student-id">{{ studentProfile.student.code }}</p>
          <p class="student-firstname">
            <a @click.prevent="navigateTo('app.profile')">{{ studentProfile.student.name }}</a>
          </p>
          <p class="student-program">{{ formattedProgramLine }}</p>

          <div class="risk-level-info">
            <span class="risk-level-value">{{
              studentProfile.student.desertionProbability | percentage
            }}</span>

            {{ riskDescription }}
          </div>
        </div>
      </div>
    </div>
    <div class="contact has-background-white">
      <div class="contact-basic">
        <h4 class="title">CONTACTO</h4>
        <!-- PHONES -->
        <div
          v-for="(item, index) in studentProfile.student.phoneNumbers"
          :key="index"
          class="contact-item"
        >
          <span class="contact-item-icon" :class="{ invisible: index != 0 }">
            <telephone-icon />
          </span>
          <a class="contact-item-value" :href="callTo(item)">{{ item }}</a>
        </div>

        <div style="height: 7px;"></div>

        <!-- EMAILS -->
        <div
          v-for="(item, index) in studentProfile.student.emailAddresses"
          :key="index + 99"
          class="contact-item"
        >
          <span class="contact-item-icon" :class="{ invisible: index != 0 }">
            <mail-icon />
          </span>
          <a class="contact-item-value" :href="mailTo(item)">{{ item }}</a>
        </div>
      </div>
      <div class="student-enrollment">
        <h4 class="title">MATRÍCULA</h4>
        <p class="description">{{ enrolledSinceText }}</p>
      </div>

      <div class="student-responsible" v-if="this.studentProfile.student.responsible">
        <h4 class="title">RESPONSABLE</h4>
        <p class="description">{{ responsibleName }}</p>
      </div>
    </div>
    <div class="more-info has-text-grey has-background-white fs-14">
      <a href="#" @click.prevent="navigateTo('app.profile.info')">+ Más información</a>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag"
import STUDENT_PROFILE from "./graphql/StudentProfile.gql"

import TelephoneIcon from "@/components/_base/TelephoneIcon.vue"
import MailIcon from "@/components/_base/MailIcon.vue"
import EditIcon from "@/components/_base/EditIcon.vue"
import ArrowIcon from "@/components/_base/ArrowIcon.vue"
import IconWarningWhite from "@/components/_base/IconWarningWhite.vue"
import MaleAvatar from "@/components/_base/MaleAvatar.vue"
import Pill from "@/components/_base/Pill.vue"

export default {
  name: "ProfileInfo",
  props: {
    studentId: {
      type: String
    }
  },
  apollo: {
    studentProfile: {
      query: STUDENT_PROFILE,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    }
  },
  data() {
    return {
      avatarFailed: false,
      studentProfile: {
        student: {
          responsible: {}
        }
      },
      riskDescription: "Riesgo de Deserción"
    }
  },
  computed: {
    desertionStatus() {
      const desertionProbability = this.studentProfile.student.desertionProbability

      if (
        desertionProbability == null ||
        Number.isNaN(desertionProbability) ||
        desertionProbability < 29
      ) {
        return {
          color: "success",
          label: "Riesgo bajo"
        }
      }

      if (desertionProbability >= 70) {
        return {
          color: "danger",
          label: "Riesgo alto"
        }
      }

      if (desertionProbability >= 30) {
        return {
          color: "warning",
          label: "Riesgo medio"
        }
      }
    },
    responsibleName() {
      const responsible = this.studentProfile.student.responsible || {}
      return responsible.name || "-"
    },
    enrolledSinceText() {
      // State
      const currentState = this.studentProfile.student.currentState || {}
      const state = currentState.code || "-"
      // Since term
      const sinceTerm = this.studentProfile.student.enrolledSince
      const since = (sinceTerm && sinceTerm.name) || "?"
      // Join
      return `Desde ${since}, ${state}`
    },
    formattedProgramLine() {
      const enrollments = this.studentProfile.student.enrollments || []
      if (enrollments.length == 0) {
        return "-"
      }
      const e = this.getActiveEnrollment(enrollments)
      return [
        e.program.locationName,
        e.program.shiftName,
        e.program.deparmentName,
        e.program.name
      ].join(" | ")
    },
    profileBoxStyle() {
      const statusColor = this.desertionStatus.color

      return {
        [`profile-info__details--${statusColor}`]: statusColor
      }
    },
    canEditEnrollmentState() {
      const injector = angular.element(document.body).injector()
      const permissionService = injector.get("permissionService")
      return permissionService.editEnrollmentState()
    }
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    getActiveEnrollment(enrollments) {
      let activeEnrollement = {}

      enrollments.forEach(enrollment => {
        const enrollmentState = enrollment.estado
        if (enrollment.term.actual && enrollmentState && enrollmentState.persiste) {
          activeEnrollement = enrollment
        }
      })

      if (!Object.keys(activeEnrollement).length) {
        enrollments.forEach(enrollment => {
          if (enrollment.term.actual) activeEnrollement = enrollment
        })
      }

      return activeEnrollement != {} ? activeEnrollement : enrollments[0]
    },
    callTo(phoneNumber) {
      return `tel:${phoneNumber}`
    },
    mailTo(emailAddress) {
      return `mailto:${emailAddress}`
    },
    disableAvatar() {
      this.avatarFailed = true

      // TODO
      // Send a mutation to the backend to clear the avatar url so we don't
      // load it again
    }
  },
  components: {
    TelephoneIcon,
    MailIcon,
    EditIcon,
    ArrowIcon,
    IconWarningWhite,
    MaleAvatar,
    Pill
  },
  filters: {
    percentage(value) {
      if (value == null || Number.isNaN(value)) {
        return "-"
      }
      return (value * 100).toFixed(0) + "%"
    }
  }
}
</script>

<style scoped>
p {
  font-size: 14px;
}

.invisible {
  visibility: hidden;
}

.edit-btn {
  transition: all 0.35s ease;
  opacity: 0.5;
}

.edit-btn:hover {
  opacity: 1;
}

.profile-info .profile-info__details {
  background-color: var(--color-neutral-10);
  padding: 24px 10px 10px;
  position: relative;
}

.profile-info .profile-info__details::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 10px;
  background-color: var(--color-success-50);
}

.profile-info .profile-info__details.profile-info__details--danger::after {
  background-color: var(--color-error-50);
}

.profile-info .profile-info__details.profile-info__details--warning::after {
  background-color: var(--color-warning-50);
}

.profile-info .status-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin: 0 0 8px 0;
}

.profile-pic.column,
.basic-info.column {
  padding-bottom: 0;
}
.profile-pic.column {
  padding: 0;
}

.profile-avatar-img {
  height: 100%;
  width: 100%;
  border-radius: 100%;
}

.risk-level-indicator-arrow {
  display: inline-block;
}
.risk-level-indicator-arrow.at-risk {
  transform: rotate(-45deg);
}

.risk-level-info {
  color: var(--color-neutral-90);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.risk-level-value {
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
}

.profile-info {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.profile-info__details .basic-info {
  margin: 0 !important;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
}

.profile-info__details .basic-info-content {
  padding: 0;
}

.profile-info__details .basic-info-content .student-id {
  color: var(--color-neutral-90);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
}

.profile-info__details .basic-info-content .student-firstname {
  color: var(--color-neutral-90);
  font-family: Roboto;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

.basic-info-content p {
  margin: 0;
}

.basic-info-content .student-program,
.contact .description,
.contact-item .contact-item-value {
  color: var(--color-neutral-90);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.basic-info-content .student-program {
  margin: 4px 0 24px 0;
}

.profile-pic {
  display: flex;
  justify-content: center;
}

.profile-edit {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 13px;
  margin-right: 17px;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  opacity: 0.5;
}

.profile-edit .icon {
  width: 22px;
  height: 22px;
}

.profile-pic-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
}

.fake-pic {
  display: inline-block;
  height: 80px;
  width: 80px;
  background: white;
  border-radius: 290486px;
}

/* CONTACT */
.contact {
  padding: 30px 20px;
  color: #333 !important;
  font-size: 14px !important;
}

.contact .title {
  color: var(--color-neutral-90);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  line-height: 14px;
  margin: 0;
}

.contact-item {
  margin: 7px 0;
}

.contact-item .contact-item-icon {
  width: 15px;
  display: inline-block;
  text-align: center;
}
.contact-item .contact-item-value {
  margin: 0 5px;
  text-decoration: none;
}

.student-firstname a {
  color: inherit;
  cursor: pointer;
  text-decoration: none;
}

.student-enrollment,
.student-responsible {
  margin: 30px 0;
}
.student-responsible {
  margin-bottom: 0;
}

.student-enrollment p,
.student-responsible p {
  margin: 5px 0;
}

/* MORE INFO */
.more-info {
  margin-top: 2px;
  padding: 12px 20px;
}
.more-info a {
  color: #828282;
  text-decoration: none;
}
.more-info a:hover {
  text-decoration: underline;
}
</style>
